import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { MonthInPractice } from './components/MonthInPractice';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { ProductReveal } from './components/ProductReveal';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { preTestimonials, postTestimonials } from './data/testimonials';
import { useViewContent } from './hooks/useViewContent';
export function App() {
  useViewContent();
  return <div className="min-h-screen w-full bg-ivory text-ink font-sans selection:bg-sage-tint selection:text-ink" data-id="element-0" data-mp="3mkrd9k285fcs">
      <MetaPixel data-id="element-1" data-mp="3rdas0kcnegj6" />
      <main data-id="element-2" data-mp="3rcsw5otwe4bs">
        <Hero data-id="element-3" data-mp="3rd17vdeab3le" />
        <SocialProofBar data-id="element-4" data-mp="3relw6la09qat" />
        <MonthInPractice data-id="element-5" data-mp="6hr7hlrojf6" />
        {/* Renders only once real, attributed quotes exist. */}
        <Testimonials testimonials={preTestimonials} background="white" data-id="element-6" data-mp="2zld259q0hfbj" />
        <PainGrid data-id="element-7" data-mp="2zng14j956ise" />
        <BigIdea data-id="element-8" data-mp="33mf25srr5vek" />
        <ProductReveal data-id="element-9" data-mp="33lwyib2rgewm" />
        <Volumes data-id="element-10" data-mp="33nghwajpr62m" />
        <Bonuses data-id="element-11" data-mp="33myix65o2dr0" />
        <Urgency data-id="element-12" data-mp="33ohzyyz5cstu" />
        <Pricing data-id="element-13" data-mp="38m1jadapbvsn" />
        <Transformation data-id="element-14" data-mp="38li6fazwrxlh" />
        <Testimonials testimonials={postTestimonials} title="More couples, fewer 2 a.m. spirals" background="ivory" data-id="element-15" data-mp="38k6vmr81ppkv" />
        <Guarantee data-id="element-16" data-mp="nw2a60hx7gog" />
        <Faq data-id="element-17" data-mp="nuhhkgf627t8" />
        <CostOfInaction data-id="element-18" data-mp="nv0z3w0wmu6q" />
        <Close data-id="element-19" data-mp="nxn5hsc273nd" />
      </main>
      <Footer data-id="element-20" data-mp="sudlygrs019b" />
    </div>;
}